const getCurrencies = (state) => state.currency.currencies.items
const getCurrenciesLoading = (state) => state.currency.currencies.loading
const getCurrenciesPages = (state) => state.currency.currencies.totalPages

export default {
  getCurrencies,
  getCurrenciesLoading,
  getCurrenciesPages,
}
